/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useReducer } from 'react';

import PropTypes from 'prop-types';
import reducer from '../Reducers/reducer';
import AppContext from '../Context/AppContext';
import MainStore from '../../Stores/StoreMedicine/store';

function AppContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, MainStore);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

AppContextProvider.defaultProps = {
  children: null,
};

AppContextProvider.propTypes = {
  children: PropTypes.elementType,
};

export default AppContextProvider;
